import { render } from "./lottery.vue?vue&type=template&id=380046af&scoped=true"
import script from "./lottery.vue?vue&type=script&lang=js"
export * from "./lottery.vue?vue&type=script&lang=js"

import "./lottery.vue?vue&type=style&index=0&id=380046af&lang=scss&scoped=true"
import "./lottery.vue?vue&type=style&index=1&id=380046af&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-380046af"]])

export default __exports__